import customHeaders, { getSpace } from '../../../common/headers';
import { FilterContainer } from '../../../components/FilterContainer/FilterContainer';
import { useState, useEffect, useRef } from 'react';
import { fetchFilterLaModa } from '../../../common/filtersFunc';
import { DropDownSelector, RangeBox } from '@lk-gtcom/ecomlab-components';
import useGeneralStore from '../../../store/general';
import './Filters.scss';
import { RequestController } from '../../../common/filtersFunc';
import { useURLSearchParams } from '../../../common/useURLSearchParams';

const Filters = ({
    selectedApi,
    setSelectedApi,
    selectedBrand,
    setSelectedBrand,
    isTableRequest,
    setIsTableRequest,
    date,
    setDate,
    brand = true
}) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    // Реф для хранения контроллера запросов
    const requestControllerRef = useRef(new RequestController());

    const [apiData, setApiData] = useState([]);
    const [brandData, setBrandData] = useState([]);

    const [apiPage, setApiPage] = useState(1);
    const [brandPage, setBrandPage] = useState(1);

    const [apiQuery, setApiQuery] = useState('');
    const [brandQuery, setBrandQuery] = useState('');

    const [totalApi, setTotalApi] = useState(0);
    const [totalBrand, setTotalBrand] = useState(0)


    // Конфигурация фильтров для URL параметров
    const filterConfig = [
        { key: 'api', type: 'multi' },
        { key: 'brand', type: 'multi' },
        { key: 'date_from', type: 'date' },
        { key: 'date_to', type: 'date' }
    ]

    const { urlParams, updateURL, isInitialized, hasInitialParams } = useURLSearchParams(filterConfig);
    const [isFilterRequest, setIsFilterRequest] = useState(false);
    // Инициализация фильтров из URL параметров при первом рендере
    const [isInitialLoadFromURL, setIsInitialLoadFromURL] = useState(false);

    // Инициализация фильтров из URL параметров при первом рендере
    useEffect(() => {
        if (!isInitialLoadFromURL) {
            setIsInitialLoadFromURL(true);

            // Обновляем все состояния фильтров
            setTimeout(() => {
                if (urlParams.api) setSelectedApi(urlParams.api);
                if (urlParams.brand) setSelectedBrand(urlParams.brand);
                if (urlParams.date_from) {
                    setDate([
                        new Date(parseInt(urlParams.date_from)),
                        new Date(parseInt(urlParams.date_to)),
                    ]);
                }
                // Запускаем запрос таблицы и фильтров только при первой инициализации из URL
                setIsFilterRequest(prev => !prev);
                if (Object.keys(urlParams).length > 0) {
                    setIsTableRequest(prev => !prev);
                }
            }, 10);
        }
    }, [urlParams]);

    const apiFilter = () => {
        const controller = requestControllerRef.current.createController('api');

        fetchFilterLaModa({
            controller,
            selectedSpace: selectedSpace?.value,
            setTotal: setTotalApi,
            page: apiPage,
            set: (e) => setApiData(e),
            searchParam: apiQuery,
            selectedBrand,
            filter: 'market_name_list'
        })?.finally(() => {
            requestControllerRef.current.removeController('api');
        })
    }

    useEffect(() => {
        if (!isInitialLoadFromURL) return;
        apiFilter()
    }, [isFilterRequest, apiPage, apiQuery]);

    const brandFilter = () => {
        const controller = requestControllerRef.current.createController('brand');

        fetchFilterLaModa({
            controller,
            selectedSpace: selectedSpace?.value,
            setTotal: setTotalBrand,
            page: brandPage,
            apiData,
            searchParam: brandQuery,
            selectedApi,
            set: (e) => setBrandData(e),
            filter: 'product_brand_list'
        })?.finally(() => {
            requestControllerRef.current.removeController('brand');
        })
    }

    useEffect(() => {
        if (!isInitialLoadFromURL) return;
        if (brand) {
            brandFilter()
        }
    }, [isFilterRequest, brandPage, brandQuery]);

    useEffect(() => {
        return () => {
            // Отменяем все активные запросы фильтров
            requestControllerRef.current.abortAll();
        };
    }, []);

    return (
        <div className="products-in-campaign__filters">
            <FilterContainer
                onReset={(e) => {
                    setSelectedApi([]);
                    setSelectedBrand([]);
                }}
            >
                <DropDownSelector
                    options_prop={apiData}
                    state={selectedApi}
                    total={totalApi}
                    setState={setSelectedApi}
                    placeholder="Площадка"
                    fetchCallback={setApiPage}
                    setInputChange={setApiQuery}
                    multi
                    onBlur={() => {
                        updateURL({ api: selectedApi });
                        if (brand) {
                            brandFilter()
                        }
                        setIsTableRequest(!isTableRequest)
                    }}
                />

                {brand && <DropDownSelector
                    options_prop={brandData}
                    state={selectedBrand}
                    total={totalBrand}
                    setState={setSelectedBrand}
                    placeholder="Бренд"
                    fetchCallback={setBrandPage}
                    setInputChange={setBrandQuery}
                    defaultValue={[{ label: 'Все', value: 'all' }]}
                    multi
                    onBlur={() => {
                        updateURL({ brand: selectedBrand });
                        setIsTableRequest(!isTableRequest)
                    }}
                />}
            </FilterContainer>


            <RangeBox
                date={date}
                setDate={(e) => {
                    const [newDateFrom, newDateTo] = e;
                    updateURL({
                        date_from: newDateFrom,
                        date_to: newDateTo
                    });
                    setDate(e)
                }}
            />

        </div>
    );
};

export { Filters };
